import styled from "styled-components";

import treeImage from "./tree.png";

const Image = styled.img``;

export const Tree: React.FC<{ className?: string }> = props => (
  <Image src={treeImage} className={props.className} />
);
